import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GetUserDetailOnIdBasisSlice } from '../../../../redux/features/UserManagementSlice';
import { useDispatch } from 'react-redux';

const BasicPersonal = () => {
  const {id} = useParams();
  const [data,setData] = useState({});
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(GetUserDetailOnIdBasisSlice(id)).then((res)=>{
      try {
        console.log(res)
        setData(res.payload.checkData);
      } catch (error) {
        
      }
    })
  },[id])
  return (
    <>
      <div className="Small-Wrapper">
              <div className="portfolio">
                <div className="ProfileBox">
                  <figure>
                    <img src={require(`../../../../assets/images/user.avif`)} />
                  </figure>
                  <figcaption>
                    <p>
                      <label>Name</label> <span>{data?.personalInfo?.name?.slice(0,20)}</span>
                    </p>
                    <p>
                      <label>Gender</label> <span>{data?.personalInfo?.gender}</span>
                    </p>
                    <p>
                      <label>Mobile Number</label> <span>{data?.phone}</span>
                    </p>
                    <p>
                      <label>Email Address</label> <span>{data?.personalInfo?.email}</span>
                    </p>
                    <p>
                      <label>DOB</label>
                      <span>{data?.personalInfo?.dob?.substring(0,10)}</span>
                    </p>
                  </figcaption>
                </div>
              { data?.Addresses?.length > 0 && 
                <div className="ProfileBox ProfileBox1">
                  
                  <h5>Saved Addresses</h5>

                {data?.Addresses?.map((item,index)=>{
                  return(
                    <>
                  <h6>{item?.addresstype?.charAt(0).toUpperCase() + item?.addresstype?.slice(1)}</h6>

                  <p>State : {item?.state} <span> </span></p>
                  <p>City : {item?.city} <span> </span></p>
                  <p>House Number/Flat No./Office No.: {item?.houseNo} <span> </span></p>
                  <p>Pin Code: <span>{item?.pincode}</span></p>
                  <p>Street: <span>{item?.street}</span></p>
                  <p>Land Mark: <span> {item?.landmark}</span></p>
                  <br />
                  </>
                  )
                })
                 }
                </div>
                }
              </div>
            </div> 
    </>
  )
}

export default BasicPersonal
